import { useEffect } from "react";
import NavBar from "../components/NavBar";
import Others from "../components/Other";
import Brand from "../components/Brand";
import Footer from "../components/Footer";
import PromoList from "../components/PromoList";
import HeaderPromo from "../components/HeaderPromo";

export default function Promotion() {
   useEffect(() => {
        document.title = "De belles offres vous attendent!!!";
      }, []);

  return (
    <>
    <NavBar />
    <HeaderPromo />
     <PromoList getType={null}/>
     <Others />
     <Brand />
     <Footer />
    </>
  );
}
